import { datadogLogs } from '@datadog/browser-logs'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  datadogLogs.init({
    clientToken: runtimeConfig.public.DD_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: runtimeConfig.public.DD_SERVICE,
    forwardErrorsToLogs: true,
    env: runtimeConfig.public.DD_ENV,
    version: runtimeConfig.public.DD_VERSION,
  })
})
